<template>
  <div class="bg-white rounded px-8 py-8 pb-16" v-loading="pageLoading">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-5">
          <div>
            <p class="text-deepBlue font-semibold">Profile Types</p>
          </div>
          <hr class="mb-4 mt-2" />
          <div>
            <div class="table__search-input-wrapper">
              <span class="pr-2 opacity-50"><search-icon /> </span>
              <input
                type="text"
                class="table__search-input"
                placeholder="Search..."
                v-model="profileTypeQuery"
              />
              <img src="@/assets/images/icons/search.svg" alt="search icon" />
            </div>
          </div>
          <div class="mt-8">
            <table class="w-full">
              <thead>
                <tr>
                  <th class="w-4/5">Types</th>
                  <th class="w-1/5">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(type, index) in filteredProfileTypes" :key="index">
                  <td class="font-semibold">{{ type }}</td>
                  <td class="flex cursor-pointer">
                    <span @click="editType(index)"
                      ><svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.125 16.9688H0.875C0.460156 16.9688 0.125 17.3039 0.125 17.7188V18.5625C0.125 18.6656 0.209375 18.75 0.3125 18.75H18.6875C18.7906 18.75 18.875 18.6656 18.875 18.5625V17.7188C18.875 17.3039 18.5398 16.9688 18.125 16.9688ZM3.53984 15C3.58672 15 3.63359 14.9953 3.68047 14.9883L7.62266 14.2969C7.66953 14.2875 7.71406 14.2664 7.74688 14.2313L17.682 4.29609C17.7038 4.27441 17.721 4.24866 17.7328 4.2203C17.7445 4.19195 17.7506 4.16156 17.7506 4.13086C17.7506 4.10016 17.7445 4.06977 17.7328 4.04142C17.721 4.01306 17.7038 3.98731 17.682 3.96563L13.7867 0.0679688C13.7422 0.0234375 13.6836 0 13.6203 0C13.557 0 13.4984 0.0234375 13.4539 0.0679688L3.51875 10.0031C3.48359 10.0383 3.4625 10.0805 3.45312 10.1273L2.76172 14.0695C2.73892 14.1951 2.74707 14.3243 2.78545 14.446C2.82384 14.5677 2.89132 14.6782 2.98203 14.768C3.13672 14.918 3.33125 15 3.53984 15Z"
                          fill="#383F51"
                        />
                      </svg>
                    </span>
                    <span class="pl-2" @click="deleteType(index)">
                      <svg
                        width="12"
                        height="16"
                        viewBox="0 0 12 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.857143 14.0004C0.857143 14.9433 1.62857 15.7147 2.57143 15.7147H9.42857C10.3714 15.7147 11.1429 14.9433 11.1429 14.0004V3.7147H0.857143V14.0004ZM2.57143 5.42899H9.42857V14.0004H2.57143V5.42899ZM9 1.14328L8.14286 0.286133H3.85714L3 1.14328H0V2.85756H12V1.14328H9Z"
                          fill="#A5ADB7"
                        />
                      </svg>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <empty-state
              v-if="!filteredProfileTypes.length"
              description="No profile types found!"
            />
          </div>
          <div class="mt-16">
            <primary-button
              buttonText="Add"
              @click="isProfileTypeModal = true"
            />
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-7">
          <div>
            <p class="text-deepBlue font-semibold">Contact Address</p>
          </div>

          <div class="address-options">
            <div>
              <p class="font-semibold text-sm pb-2">
                Select which address fields you need in your contact forms.
              </p>
            </div>
            <div>
              <base-checkbox v-model="selectAllAddressFields" />
              <label class="label">Show All</label>
            </div>
            <hr />
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-4 mt-3">
                  <div>
                    <base-checkbox
                      value="address"
                      v-model="settings.contactAddress"
                    />
                    <label class="label">Address</label>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-3">
                  <div>
                    <base-checkbox
                      value="country"
                      v-model="settings.contactAddress"
                    />
                    <label class="label">Country</label>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-3">
                  <div>
                    <base-checkbox
                      value="state"
                      v-model="settings.contactAddress"
                    />
                    <label class="label">State</label>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-3">
                  <div>
                    <base-checkbox
                      value="city"
                      v-model="settings.contactAddress"
                    />
                    <label class="label">City</label>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-3">
                  <div>
                    <base-checkbox
                      value="region"
                      v-model="settings.contactAddress"
                    />
                    <label class="label">Region/Province</label>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-3">
                  <div>
                    <base-checkbox
                      value="zipCode"
                      v-model="settings.contactAddress"
                    />
                    <label class="label">Zip/Postal Code</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="my-6" />
          <div>
            <div>
              <base-checkbox v-model="settings.showShippingAddress" />
              <label class="label"
                >Show shipping address in contact forms.</label
              >
            </div>
            <div>
              <base-checkbox v-model="settings.multipleAddress" />
              <label class="label">Can Add Multiple Shipping Addresses</label>
            </div>
          </div>

          <div class="mt-12">
            <base-button
              text="Update"
              color="text-darkBlue"
              width="w-24"
              background="#ecedef"
              :loading="updating"
              @click="updateContactSettings"
            />
          </div>
        </div>
      </div>
    </div>

    <profile-type-modal
      :show-modal="isProfileTypeModal"
      @close-modal="isProfileTypeModal = false"
      @update="updateProfileType($event)"
      @create="createProfileType($event)"
      :selectedProfileType="selectedProfileType"
    />

    <delete-modal
      :show-modal="isDeleteModal"
      @close-modal="isDeleteModal = false"
      :itemToDelete="selectedProfileType"
      :deletingItem="loading"
      @delete-item="deleteProfileType"
    />
  </div>
</template>

<script>
import ProfileTypeModal from "../Modals/ProfileTypeForm";
import DeleteModal from "@/components/UI/Modal/DeleteModal";
export default {
  name: "contact",
  components: {
    ProfileTypeModal,
    DeleteModal,
  },
  data() {
    return {
      profileTypes: [],
      isProfileTypeModal: false,
      newProfileName: "",
      selectedAddressFields: [],
      showShippingAddress: false,
      multipleAddress: false,
      selectedProfileType: "",
      isDeleteModal: false,
      selectedProfileTypeIndex: null,
      loading: false,
      updating: false,
      selectAllAddressFields: false,
      pageLoading: false,
      profileTypeQuery: "",
      isEditProfileType: false,
      settings: {
        contactAddress: [],
        multipleAddress: false,
        profileType: [],
        showShippingAddress: false,
      },
    };
  },
  computed: {
    filteredProfileTypes() {
      let filteredProfileTypes = [];
      this.settings.profileType.forEach((profileType) => {
        if (
          profileType
            .toLowerCase()
            .includes(this.profileTypeQuery.toLowerCase())
        ) {
          filteredProfileTypes.push(profileType);
        }
      });
      return filteredProfileTypes;
    },
  },
  watch: {
    selectAllAddressFields(val) {
      if (val) {
        this.settings.contactAddress = [
          "address",
          "country",
          "state",
          "city",
          "region",
          "zipCode",
        ];
      } else {
        this.settings.contactAddress = [];
      }
    },
  },
  mounted() {
    this.getContactSettings();
  },
  methods: {
    async getContactSettings() {
      this.pageLoading = true;
      try {
        const response = await this.$_getContactSettings();
        this.logResponse(response);
        // this.profileTypes = response.data.message.setting.profileType;
        this.settings = response.data.message.setting;
      } catch (error) {
        this.handleError(error);
      }
      this.pageLoading = false;
    },
    async updateContactSettings() {
      this.loading = true;
      this.updating = true;
      let payload = {
        payload: {
          setting: {
            ...this.settings,
          },
        },
      };
      try {
        const response = await this.$_updateContactSettings(payload);
        this.logResponse(response);
        this.generateToast("Updated successfully!", "success");
        this.getContactSettings();
      } catch (error) {
        this.handleError(error);
      }
      this.isProfileTypeModal = false;
      this.isDeleteModal = false;
      this.updating = false;
      this.loading = false;
    },
    updateProfileType(profileType) {
      let index = this.settings.profileType.indexOf(this.selectedProfileType);
      this.settings.profileType[index] = profileType;
      this.updateContactSettings();
    },
    createProfileType(profileType) {
      this.settings.profileType.push(profileType);
      this.updateContactSettings();
    },
    deleteProfileType() {
      this.settings.profileType.splice(this.selectedProfileTypeIndex, 1);
      this.updateContactSettings();
    },
    editType(index) {
      this.selectedProfileType = this.settings.profileType[index];
      this.isProfileTypeModal = true;
    },
    deleteType(index) {
      // this.profileTypes.splice(index, 1);
      this.selectedProfileType = this.settings.profileType[index];
      this.selectedProfileTypeIndex = index;
      this.isDeleteModal = true;
    },
  },
};
</script>

<style scoped>
tr:nth-child(odd) {
  background-color: #f6f9fc;
}
thead tr {
  background: #ffffff !important;
}
td {
  padding: 1rem 0;
  font-size: 1rem;
}
.address-options {
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid #dae8f6;
  border-radius: 5px;
}
.label {
  font-weight: 600;
  font-size: 0.9rem;
  padding-left: 0.5rem;
}
</style>
